// Generated by scripts/generate-svg-components.mjs. Do not edit manually.
export const FDK_ICON_NAMES = [
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'checkmark',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'cross',
  'error',
  'filter',
  'location-off',
  'location-on',
  'message',
  'plus',
  'success',
  'support',
  'user',
  'warning',
] as const;

export type FdkIconName = typeof FDK_ICON_NAMES[number];
